// 表单对外链接路由
const routes = [
    {
		path: "/formshare/:id",
		component: () => import(/* webpackChunkName: "login" */ '@/views/service/develop-online/form/pages/form-new/common/formLink'),
		meta: {
			title: "表单填写"
		}
	},
    {
		path: "/formquery/:id",
		component: () => import(/* webpackChunkName: "login" */ '@/views/service/develop-online/form/pages/form-new/common/formQuery'),
		meta: {
			title: "表单查询"
		}
	},
	{
		path: "/l/:id/d/:id",
		component: () => import(/* webpackChunkName: "login" */ '@/views/service/link-sharing/formDetailShare'),
		meta: {
			title: "表单详情"
		}
	},
]
export default routes;